// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  offerId: __t.u64().primaryKey().name("offer_id"),
  worldId: __t.u64().name("world_id"),
  chapter: __t.u8(),
  hour: __t.u8(),
  weather: __t.string(),
  whyNow: __t.string().name("why_now"),
  source: __t.u8(),
  postedWeek: __t.u64().name("posted_week"),
  timeJumpWeeks: __t.u8().name("time_jump_weeks"),
  timeJump: __t.string().name("time_jump"),
});
